export function getCart() {
    try { return JSON.parse(localStorage.getItem("sudigi_cart") || "null") || { service_slugs: [], package_slug: null }; }
    catch (e) { return { service_slugs: [], package_slug: null }; }
}
export function setCart(cart) { localStorage.setItem("sudigi_cart", JSON.stringify(cart)); }
export function buyService(slug) { setCart({ service_slugs: [slug], package_slug: null }); }
export function buyPackage(slug) { setCart({ service_slugs: [], package_slug: slug }); }
export function buyCustom(slugs) { setCart({ service_slugs: slugs, package_slug: null }); }
